"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("@emotion/css");
const __theme_1 = __importDefault(require("./_.theme"));
exports.default = {
    label: (0, css_1.css)({
        'display': 'block',
        'fontSize': '15px',
        'padding': '0 0 0 20px',
        'margin': '0',
        'color': __theme_1.default.base04,
        ':hover': {
            color: __theme_1.default.base0B,
        },
    }),
    input: (0, css_1.css)({
        margin: '0 5px 0 0',
    }),
};
